/**
 * Get the default URL for the server.
 */
export function getDefaultServerURL(servers) {
    var server = servers[0];
    if (!server) {
        // Return empty string if no server is found to display nothing
        return '';
    }
    return interpolateServerURL(server);
}
/**
 * Interpolate the server URL with the default values of the variables.
 */
export function interpolateServerURL(server) {
    var _a;
    var parts = parseServerURL((_a = server === null || server === void 0 ? void 0 : server.url) !== null && _a !== void 0 ? _a : '');
    return parts
        .map(function (part) {
        var _a, _b, _c;
        if (part.kind === 'text') {
            return part.text;
        }
        return (_c = (_b = (_a = server.variables) === null || _a === void 0 ? void 0 : _a[part.name]) === null || _b === void 0 ? void 0 : _b.default) !== null && _c !== void 0 ? _c : "{".concat(part.name, "}");
    })
        .join('');
}
function parseServerURL(url) {
    var parts = url.split(/{([^}]+)}/g);
    var result = [];
    for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        if (!part) {
            continue;
        }
        if (i % 2 === 0) {
            result.push({ kind: 'text', text: part });
        }
        else {
            result.push({ kind: 'variable', name: part });
        }
    }
    return result;
}
